<template>
    <ValidationObserver
      :ref="refName"
      :name="refName"
      tag="div"
    >
      <div
        class="d-flex justify-space-between px-0"
        :class="{
          'flex-column pb-6': isBookingFormNarrow,
          'align-items-center pb-4': !isBookingFormNarrow,
        }"      >
        <div
          class="d-flex body-2 p-0"
          :class="{ 'pb-3': isBookingFormNarrow }"
        >
          <VIcon class="mr-2">
            {{ icon }}
          </VIcon>
          <div>
            <span class="body-1">{{ $t(nameKey) }}</span>
          </div>
        </div>
        <VSpacer />
        <CustomCounter
          :dataTest="dataTest"
          :amount="amount"
          :maxValue="maxValue"
          :hint="$t('bookingForm.validations.maximumSeatsAreReached', { value: maxStandardSeatCapacity })"
          :rules="{
            atLeastOnePassenger: [adultsAmount, childrenAmount],
            amountOfPassengerIsValid: [adultsAmount, childrenAmount, maxStandardSeatCapacity],
            wheelchairPlacesCompareWithPassengers: [wheelchairPlacesAmount, passengersAmount],
          }"
          @updateAmount="updateAmount"
        />
      </div>
    </ValidationObserver>
</template>

<script lang="ts">
export default {
  name: 'PassengerItem',
};
</script>

<script setup lang="ts">
import CustomCounter from '@slg/web-customer-shared/src/components/common/CustomCounter.vue';

const props = defineProps({
  maxStandardSeatCapacity: {
    type: Number,
    default: null,
  },
  maxValue: {
    type: Number,
    default: null,
  },
  amount: {
    type: Number,
    default: null,
  },
  adultsAmount: {
    type: Number,
    default: null,
  },
  childrenAmount: {
    type: Number,
    default: null,
  },
  wheelchairPlacesAmount: {
    type: Number,
    default: null,
  },
  passengersAmount: {
    type: Number,
    default: null,
  },
  icon: {
    type: String,
    default: null,
  },
  dataTest: {
    type: String,
    default: null,
  },
  refName: {
    type: String,
    default: null,
  },
  className: {
    type: String,
    default: null,
  },
  nameKey: {
    type: String,
    default: null,
  },
  isBookingFormNarrow: {
    type: Boolean,
    default: false,
  },
  updateAmountCallback: {
    type: Function,
    default: null,
  },
});

function updateAmount(newValue) {
  props.updateAmountCallback(newValue);
}
</script>
